module.exports = __webpack_public_path__ + "static/img/wxLogo.05470660.png";